$(function () {
    // Module Slider using Splide slider
    var num_splides = document.querySelectorAll('.mod-tool-4__section .splide')

    if (num_splides.length > 0) {
        var splide = new Splide('.mod-tool-4__section .splide', {
            perPage: 1,
        })

        splide.on('mounted', function () {
            $('.splide').css({
                overflow: 'visible',
                visibility: 'visible',
                height: 'auto',
            })
        })

        splide.on('mounted move', () => {
            const slides = splide.Components.Slides.get()
            const activeIndex = splide.index
            const totalSlides = slides.length

            slides.forEach((slide, index) => {
                const el = slide.slide
                const isActive = index === activeIndex

                el.setAttribute('tabindex', isActive ? '0' : '-1')
                el.setAttribute('aria-hidden', isActive ? 'false' : 'true')
                el.setAttribute('aria-label', `Slide ${index + 1} of ${totalSlides}`)
                el.removeAttribute('role')
                el.removeAttribute('aria-roledescription')
            })
        })

        splide.mount()
    }

    // Module Slider using bxSlider
    // ------------------------------------
    ;(function (win, doc) {
        var $moduleSliderEl = $('.module-slider')
        var numSlides = $moduleSliderEl.find('.module-slider-slide').length
        var maxIndex = 1
        var moduleSliderInstance
        var moduleSliderConfig
        var matchedProps

        var moduleSliderBreakpoints = {
            mobile: {
                mq: 'only screen and (min-width: 0px)',
                slideWidth: 300,
                slides: 1,
            },
            tablet: {
                mq: 'only screen and (min-width: 750px)',
                slideWidth: 300,
                slides: 2,
            },
            desktop: {
                mq: 'only screen and (min-width: 970px)',
                slideWidth: 300,
                slides: 3,
            },
        }

        // Default slider config
        var moduleSliderConfig = {
            moveSlides: 1,
            slideMargin: 20,
            pager: false,
            speed: 500,
            infiniteLoop: false,
            nextSelector: '.module-slider-controls-next',
            nextText: '<i class="button-arrow-normal-right icon-sm"></i>',
            prevSelector: '.module-slider-controls-prev',
            prevText: '<i class="button-arrow-normal-left icon-sm"></i>',
            touchEnabled: false,
        }

        /**
         * Updates the visibility of the 'prev' and 'next' buttons
         * @param  {Object} $slideEl  jQuery instance of the slide it goes to
         * @param  {Number} fromIndex Index of the slide it came from
         * @param  {Number} toIndex   Index of the slide it goes to
         * @return {void}
         */
        moduleSliderConfig.onSlideBefore = function ($slideEl, fromIndex, toIndex) {
            $(moduleSliderConfig.prevSelector).toggleClass('hide', !toIndex)
            $(moduleSliderConfig.nextSelector).toggleClass('hide', toIndex >= maxIndex)
        }

        /**
         * Calculates some custom slider settings based on the current device width and
         * updates the config settings. After that it initializes the slider
         * @return {void}
         */
        function init() {
            // Don't run if we have no element to bind on
            if (!$moduleSliderEl.length) return

            // Check if the current device width matches a breakpoint.
            for (var device in moduleSliderBreakpoints) {
                if (win.matchMedia(moduleSliderBreakpoints[device].mq).matches) {
                    // We have a match, set the props
                    matchedProps = moduleSliderBreakpoints[device]

                    // Update the maxIndex, which is basically the number of slides minus the
                    // number of slides shown from the start
                    maxIndex = numSlides - matchedProps.slides
                }
            }

            // Set the custom config settings
            moduleSliderConfig.slideWidth = matchedProps.slideWidth
            moduleSliderConfig.minSlides = matchedProps.slides
            moduleSliderConfig.maxSlides = matchedProps.slides

            // Either init or update the slider
            if (!moduleSliderInstance) moduleSliderInstance = $moduleSliderEl.bxSlider(moduleSliderConfig)
            else moduleSliderInstance.reloadSlider(moduleSliderConfig)

            $('.module-slider-slide a').on('click', function (e) {
                e.stopPropagation()
                var href = $(this).attr('href')
                window.location.href = href
            })
        }

        // Initialize the slider again on resizing
        $(win).on('resize', $.debounce(500, init))

        // Run it
        init()
    })(window, document)
})
